<!-- <ngx-loading-bar [includeSpinner]="false" height="3px"></ngx-loading-bar> -->
<app-pwa-install></app-pwa-install>
<mat-progress-bar *ngIf="_ls.progress$ | async as progress" mode="indeterminate" [value]="progress"
  class="h-[3px]"></mat-progress-bar>
<app-toastr></app-toastr>
<div [@routeAppAnimation]="o.isActivated ? o.activatedRoute : ''" class="flex-1 overflow-hidden relative">
  <router-outlet #o="outlet" class="mat-app-background">
    <app-spinner></app-spinner>
  </router-outlet>
</div>
